import { render, staticRenderFns } from "./QScoreCardRegistrations.vue?vue&type=template&id=b56c8e3e&scoped=true&"
import script from "./QScoreCardRegistrations.vue?vue&type=script&lang=js&"
export * from "./QScoreCardRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56c8e3e",
  null
  
)

export default component.exports